import {  FaRegSmile,FaSignOutAlt } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Dialog, DialogActions, DialogTitle } from "@mui/material";
import { useState } from "react";

/* eslint-disable react/prop-types */
const MainCard = () => {
  const { user } = useSelector((state) => state.Language);
  const [openModal, setOpenModal] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();

  function onClickHandler() {
    if (user && user !== "Guest User") {
      navigate("/mood");
    } else {
      setOpenModal(true);
    }
  }

  function onClickLoginHandler() {
    navigate("/login");
  }

  return (
    <>
      <div
        className="flex gap-6  bg-[#4cadc9] sm:py-[0.8rem] md:py-5  lg:py-5 py-5 rounded-full px-3 items-center"
        onClick={onClickHandler}
      >
        <FaRegSmile className="text-yellow-200 text-2xl lg:text-3xl" />
        <p className="text-white text-sm lg:text-base md:text-base font-semibold tracking-wider">
          {t("HOW_ARE_YOU_FEELING_TODAY")}
        </p>
      </div>

      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          className="flex modal-justify-center flex-col items-center modal-content"
        >
          <FaSignOutAlt className="text-center text-[3.5rem] text-gray-300 my-3" />
          <p className="text-base mb-0 text-center text-gray-600 font-normal">
          {t("LOGIN_TO_REGISTER_YOUR_MOOD")}
          </p>
        </DialogTitle>
        <DialogActions className="flex modal-justify-center">
          <button
            type="button"
            className="bg-gray-400  uppercase text-xs mt-4 mb-2 px-4 rounded-md text-white py-2 shadow shadow-slate-400"
            onClick={() => setOpenModal(false)}
            autoFocus
          >
            SKIP
          </button>
          <button
            type="button"
            className="bg-default  uppercase text-xs mt-4 mb-2 px-4 rounded-md text-white py-2 shadow shadow-slate-400 "
            onClick={onClickLoginHandler}
            autoFocus
          >
            LOGIN
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default MainCard;
